import React from 'react';
import { HeaderBlock, RowCenter } from './Auth.style';
import MedicineSnake from '../../assets/allIcons/MedicineSnake';

const AuthHeader = () => {

    return (
        <>
            <RowCenter>
                <MedicineSnake />
            </RowCenter>
        </>
    )
}

export default AuthHeader;
